import { PropsWithChildren, useState } from "react";
import { Voucher } from "@/types";

import { DialogResponsive } from "../../dialogs";
import { FormCreateVoucher } from "./form-create-voucher";
import { FormUpdateVoucher } from "./form-update-voucher";

type FormVoucherProps = PropsWithChildren & {
  voucher?: Voucher;
};

export function FormVoucher({ children, voucher }: FormVoucherProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={voucher ? "Atualizar voucher" : "Novo voucher"}
      description={
        voucher
          ? "Preencha os campos para atualizar o voucher."
          : "Preencha os campos para criar uma novo voucher."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
      className="max-w-5xl 2xl:max-w-6xl w-full h-auto"
    >

      {voucher ? (
        <FormUpdateVoucher
          voucher={voucher}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateVoucher handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
